import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../../redux/actions/user-actions";
import * as sidebarAction from "../../../redux/actions/sidebar-actions";
import LanguageSwitcher from "../../../languageSwitcher";

import IntlMessages from "../../../services/intlMesseges";
import { Tooltip, Icon, Row, Col, Menu, Dropdown, Badge } from "antd";
import * as notificationActions from "../../../redux/actions/notifications-actions";

class AdminHeader extends Component {
  state = {
    collapsed: true,
    data: [],
    notificationsCount: 0
  }

  profile = () => (
    <Menu style={{ width: 200 }}>
      <Menu.Item key="0">
        <Link to="/admin/my-profile">My Profile</Link>
      </Menu.Item>
      <Menu.Item key="0">
        <Link to="/admin/my-profile/change-password">Change Password</Link>
      </Menu.Item>
      <Menu.Item key="0" onClick={this.logout}>
        <span>Log Out</span>
      </Menu.Item>
    </Menu>
  );

  constructor(props) {
    super(props);
    this.state = { collapsed: true };
    this.logout = this.logout.bind(this);
  }
  toggle = () => {
    this.props.toggleSidebar();
  };
  logout() {
    this.props.LogOutUser();
    this.props.history.push("/login");
  }
  async componentDidMount() {
    this.props.getNotificationsList({}).then(data => {
      if(this.props.userData && this.props.userData.userID){
        this.props.getNotificationsCount(this.props.userData.userID).then(r => this.setState({notificationsCount: r}));
      }
      let _data = data.data
      if (_data && _data.length>0){
        _data.splice(5);

      }
      this.setState({ 
        data: _data
      })
    })
  }
  onLoadMore = () => {
    this.props.history.push('/admin/notifications/')
  };
  
  notificationsList = () => {
    let notifications = this.state.data || [];
    let output = [];
    let _this = this;
    if(notifications.length > 0){
      notifications.map(function(n){
        output.push(<Menu.Item key={n.notificationMessagesId} onClick={() => _this.props.history.push("/admin/notifications/")}><Tooltip title={<IntlMessages id="admin.manageOrders.View" />}>
        {n.title.length > 27 ? n.title.substring(0,27)+"...":n.title}
        </Tooltip></Menu.Item>);
        return n;
      });
      output = <Menu className="notification-msg" style={{ width: 280 }}>{output}</Menu>;
    }
    return output;
  }

  render() {
    /* const { initLoading, loading, list } = this.state;
    const loadMore =
      !initLoading && !loading ? (
        <div
          style={{
            textAlign: 'center',
            marginTop: 12,
            height: 32,
            lineHeight: '32px',
          }}
        >
          <Button onClick={this.onLoadMore}>loading more</Button>
        </div>
      ) : null; */
    let currentUserFirstname = this.props.userData.firstName;
    let currentUserLastname = this.props.userData.lastName;
    return (
      <div>
        <Row>
          <Col xs={3}>
            <Icon className='trigger' type={!this.props.sidebar ? 'menu-unfold' : 'menu-fold'} onClick={this.toggle} />
          </Col>

          <Col xs={21}>
            <ul>
              {/* <li>
                <button
                style={{paddingLeft:'20px'}}
                  className='icon'
                  onClick={() => {
                    this.props.history.push('/admin/search');
                  }}
                >
                    <i class='fas fa-search' aria-hidden='true'></i>
                </button>
              </li> */}
              {this.props.notificationCount > 0 ? (
                <li>
                  <Dropdown overlay={this.notificationsList} trigger={['click']}>
                    <Badge style={{ background: '#2c6ba7' }} count={this.props.notificationCount}>
                      <a className='ant-dropdown-link bell-icon' href='#'>
                        <i className='fas fa-bell'></i>
                      </a>
                    </Badge>
                  </Dropdown>
                </li>
              ) : (
                <li>
                  <a
                    className='ant-dropdown-link bell-icon'
                    onClick={() => this.props.history.push('/admin/notifications/')}
                  >
                    <i className='fas fa-bell'></i>
                  </a>
                </li>
              )}
              <li>
                <LanguageSwitcher />
              </li>

              <li>
                <Dropdown overlay={this.profile} trigger={['click']}>
                  <a className='ant-dropdown-link' href='#'>
                    <i className='fas fa-user-circle'></i>
                    <span className='name'>
                      {currentUserFirstname} {currentUserLastname}
                    </span>
                  </a>
                </Dropdown>
              </li>
            </ul>
          </Col>
        </Row>
      </div>
    );
  }
}

AdminHeader.propTypes = {
  LogOutUser: PropTypes.func,
  isLoggedIn: PropTypes.bool,
  toggleSidebar: PropTypes.func,
  notificationCount: PropTypes.number
};

function mapStateToProps(state) {
  return {
    ...state.user,
    ...state.sidebar
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...userActions, ...sidebarAction, ...notificationActions }, dispatch);
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AdminHeader)
);
